// Central logging helpers – stripped from production build by tree-shaking
// -------------------------------------------------------------------------

// Keep a single source of truth for “are we running a dev build?”.  Bundlers
// such as Webpack, Rollup or Vite statically replace `process.env.NODE_ENV`
// with the corresponding string at compile time, allowing terser/uglify to
// drop the dead branch so that the resulting production bundle contains only
// the tiny `noop` functions (or even nothing at all once inlined).

export const __DEV__ = process.env.NODE_ENV !== 'production'

type LogFn = (...args: unknown[]) => void

const noop: LogFn = () => {}

// Generic helpers without namespace – handy for quick one-offs
export const debug: LogFn = __DEV__ ? console.log.bind(console) : noop
export const debugError: LogFn = __DEV__ ? console.error.bind(console) : noop
export const debugWarn: LogFn = __DEV__ ? console.warn.bind(console) : noop

// -------------------------------------------------------------------------
// Scoped logger factory
// -------------------------------------------------------------------------

/**
 * Create a set of namespaced console helpers that are no-ops in production.
 *
 * Example:
 *   const { debug, error } = getLogger('TokenService')
 *   debug('token acquired', token)
 *
 * In production the calls will be compiled away (or resolve to a cheap noop),
 * keeping the runtime overhead and bundle size to a minimum.
 */
export const getLogger = (namespace: string): { debug: LogFn; error: LogFn; warn: LogFn } => ({
  debug: __DEV__ ? console.log.bind(console, `[${namespace}]`) : noop,
  error: __DEV__ ? console.error.bind(console, `[${namespace}]`) : noop,
  warn: __DEV__ ? console.warn.bind(console, `[${namespace}]`) : noop,
})
